// source: gw/servicepr/refund.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.BankInfo', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.PreferRefundRequest', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.PreferRefundResponse', null, global);
goog.exportSymbol('proto.coconala.protobuf.gw.servicepr.RefundStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest.displayName = 'proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.displayName = 'proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.BankInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.BankInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.BankInfo.displayName = 'proto.coconala.protobuf.gw.servicepr.BankInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.PreferRefundRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.PreferRefundRequest.displayName = 'proto.coconala.protobuf.gw.servicepr.PreferRefundRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.coconala.protobuf.gw.servicepr.PreferRefundResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.displayName = 'proto.coconala.protobuf.gw.servicepr.PreferRefundResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest;
  return proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    refundEnabled: (f = msg.getRefundEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    refundStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    refundStartDate: (f = msg.getRefundStartDate()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    refundAmount: (f = msg.getRefundAmount()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    chargeAmount: (f = msg.getChargeAmount()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    bankInfo: (f = msg.getBankInfo()) && proto.coconala.protobuf.gw.servicepr.BankInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse;
  return proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setRefundEnabled(value);
      break;
    case 2:
      var value = /** @type {!proto.coconala.protobuf.gw.servicepr.RefundStatus} */ (reader.readEnum());
      msg.setRefundStatus(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRefundStartDate(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setRefundAmount(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setChargeAmount(value);
      break;
    case 6:
      var value = new proto.coconala.protobuf.gw.servicepr.BankInfo;
      reader.readMessage(value,proto.coconala.protobuf.gw.servicepr.BankInfo.deserializeBinaryFromReader);
      msg.setBankInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRefundEnabled();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRefundStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getRefundStartDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRefundAmount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getChargeAmount();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getBankInfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.coconala.protobuf.gw.servicepr.BankInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.BoolValue refund_enabled = 1;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.getRefundEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 1));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.setRefundEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.clearRefundEnabled = function() {
  return this.setRefundEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.hasRefundEnabled = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RefundStatus refund_status = 2;
 * @return {!proto.coconala.protobuf.gw.servicepr.RefundStatus}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.getRefundStatus = function() {
  return /** @type {!proto.coconala.protobuf.gw.servicepr.RefundStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.coconala.protobuf.gw.servicepr.RefundStatus} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.setRefundStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue refund_start_date = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.getRefundStartDate = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.setRefundStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.clearRefundStartDate = function() {
  return this.setRefundStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.hasRefundStartDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Int32Value refund_amount = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.getRefundAmount = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.setRefundAmount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.clearRefundAmount = function() {
  return this.setRefundAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.hasRefundAmount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Int32Value charge_amount = 5;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.getChargeAmount = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.setChargeAmount = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.clearChargeAmount = function() {
  return this.setChargeAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.hasChargeAmount = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional BankInfo bank_info = 6;
 * @return {?proto.coconala.protobuf.gw.servicepr.BankInfo}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.getBankInfo = function() {
  return /** @type{?proto.coconala.protobuf.gw.servicepr.BankInfo} */ (
    jspb.Message.getWrapperField(this, proto.coconala.protobuf.gw.servicepr.BankInfo, 6));
};


/**
 * @param {?proto.coconala.protobuf.gw.servicepr.BankInfo|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.setBankInfo = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.clearBankInfo = function() {
  return this.setBankInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.GetRefundInfoResponse.prototype.hasBankInfo = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.BankInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.BankInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    bankCode: (f = msg.getBankCode()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    bankName: (f = msg.getBankName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    branchCode: (f = msg.getBranchCode()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    branchName: (f = msg.getBranchName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    accountType: (f = msg.getAccountType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    accountNumber: (f = msg.getAccountNumber()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    accountName: (f = msg.getAccountName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.BankInfo;
  return proto.coconala.protobuf.gw.servicepr.BankInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.BankInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setBankCode(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBankName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setBranchCode(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBranchName(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAccountType(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setAccountNumber(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAccountName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.BankInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.BankInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBankCode();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getBankName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBranchCode();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getBranchName();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAccountType();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAccountNumber();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getAccountName();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value bank_code = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.getBankCode = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.setBankCode = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.clearBankCode = function() {
  return this.setBankCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.hasBankCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue bank_name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.getBankName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.setBankName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.clearBankName = function() {
  return this.setBankName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.hasBankName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Int32Value branch_code = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.getBranchCode = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.setBranchCode = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.clearBranchCode = function() {
  return this.setBranchCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.hasBranchCode = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue branch_name = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.getBranchName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.setBranchName = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.clearBranchName = function() {
  return this.setBranchName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.hasBranchName = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue account_type = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.getAccountType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.setAccountType = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.clearAccountType = function() {
  return this.setAccountType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.hasAccountType = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Int32Value account_number = 6;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.getAccountNumber = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 6));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.setAccountNumber = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.clearAccountNumber = function() {
  return this.setAccountNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.hasAccountNumber = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue account_name = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.getAccountName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
*/
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.setAccountName = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.BankInfo} returns this
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.clearAccountName = function() {
  return this.setAccountName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.BankInfo.prototype.hasAccountName = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.PreferRefundRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.PreferRefundRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.PreferRefundRequest}
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.PreferRefundRequest;
  return proto.coconala.protobuf.gw.servicepr.PreferRefundRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.PreferRefundRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.PreferRefundRequest}
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.PreferRefundRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.PreferRefundRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.coconala.protobuf.gw.servicepr.PreferRefundResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    refundAmount: (f = msg.getRefundAmount()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.coconala.protobuf.gw.servicepr.PreferRefundResponse}
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.coconala.protobuf.gw.servicepr.PreferRefundResponse;
  return proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.coconala.protobuf.gw.servicepr.PreferRefundResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.coconala.protobuf.gw.servicepr.PreferRefundResponse}
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setRefundAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.coconala.protobuf.gw.servicepr.PreferRefundResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRefundAmount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value refund_amount = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.prototype.getRefundAmount = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.coconala.protobuf.gw.servicepr.PreferRefundResponse} returns this
*/
proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.prototype.setRefundAmount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.coconala.protobuf.gw.servicepr.PreferRefundResponse} returns this
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.prototype.clearRefundAmount = function() {
  return this.setRefundAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.coconala.protobuf.gw.servicepr.PreferRefundResponse.prototype.hasRefundAmount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.coconala.protobuf.gw.servicepr.RefundStatus = {
  DEFAULT: 0,
  IN_PROGRESS: 1
};

goog.object.extend(exports, proto.coconala.protobuf.gw.servicepr);
